import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-5 sm:grid-cols-3" }
const _hoisted_2 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_3 = { class: "mt-1 text-sm text-gray-900" }
const _hoisted_4 = { class: "mt-1 text-sm text-gray-900" }

import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import NeueButton from '@/components/neue/NeueButton.vue'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { signOut as endSession } from '@/helpers/signOut'


export default {
  __name: 'FranchiseAccount',
  setup(__props) {

const store = useStore()
const router = useRouter()

const attributes = computed(() => store.state.franchise?.attributes || {})

const signOut = () => endSession({ store, router })

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, { text: "Account" })
    ]),
    main: _withCtx(() => [
      _createVNode(SettingsSection, {
        title: "Your franchise",
        description: "The franchise you manage and the address you sign in with."
      }, {
        default: _withCtx(() => [
          _createElementVNode("dl", _hoisted_1, [
            _createElementVNode("div", null, [
              _cache[0] || (_cache[0] = _createElementVNode("dt", { class: "text-sm font-semibold text-gray-700" }, "Franchise", -1)),
              _createElementVNode("dd", _hoisted_2, _toDisplayString(attributes.value.name), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[1] || (_cache[1] = _createElementVNode("dt", { class: "text-sm font-semibold text-gray-700" }, "Name", -1)),
              _createElementVNode("dd", _hoisted_3, _toDisplayString(attributes.value.principal_name), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[2] || (_cache[2] = _createElementVNode("dt", { class: "text-sm font-semibold text-gray-700" }, "Email", -1)),
              _createElementVNode("dd", _hoisted_4, _toDisplayString(attributes.value.principal_email), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SettingsSection, {
        title: "Session",
        description: "Sign out of Bottle on this browser.",
        flush: ""
      }, {
        default: _withCtx(() => [
          _createVNode(NeueButton, {
            type: "secondary",
            onClick: signOut
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Sign out", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

}